import React from 'react'

import Header from '../Menhome/Header'
import Bredcom from '../MenTeam/Bredcom'
import Footer from '../Menhome/Footer'
import TermsAndConditions from '../Menpages/terms-and-conditions/main'


function TnC() {
  return (
    <>
    <Header/>
    <Bredcom title={"Policies"} head={"TERMS & CONDITIONS"} sbtitle={"Terms & Conditions"}/>
    <TermsAndConditions/>
    <Footer/>
    </>
  )
}

export default TnC;